import React, { FC, Fragment } from 'react'
import { Container, Link } from 'components/ui'
import { BreadcrumbSeparator } from 'components/icons'
import { slugify } from 'helpers/slugfy'
import cn from 'classnames'
import { MobileView } from 'react-device-detect'
import type { BreadcrumbProps, CrumbProps } from '.'
import DeliveryArea from '../delivery-area'
import s from './breadcrumb.module.css'

const Breadcrumb: FC<BreadcrumbProps> = ({ crumbs, separator, isHome }) => {
  if ((crumbs && crumbs.length < 1) || !crumbs) {
    return null
  }

  crumbs.unshift({ url: '/', label: 'Home' } as unknown as CrumbProps)

  const last = crumbs.length - 1

  const items = crumbs.map(({ url, label }, i) => (
    <Fragment key={`breadcrumb-${slugify(label)}`}>
      {i < last && url ? (
        <Link href={url} className={cn(s.link, i === last && s.last)}>
          {label}
        </Link>
      ) : (
        <span className={cn(i === last && s.last)}>{label}</span>
      )}

      {i < last && <span className={s.separator}>{separator || <BreadcrumbSeparator />}</span>}
    </Fragment>
  ))

  if (isHome) {
    return (
      <MobileView>
        <div className={s.root}>
          <Container>
            <DeliveryArea />
          </Container>
        </div>
      </MobileView>
    )
  }

  return (
    <div className={s.root}>
      <Container>
        <MobileView>
          <DeliveryArea />
        </MobileView>
        <div className={s.list}>{items}</div>
      </Container>
    </div>
  )
}

export default Breadcrumb
